export const GenerateUserIdApiPath = '/user-id/generate';
export const generateUserId = async axios => {
  const {
    data
  } = await axios.get(GenerateUserIdApiPath);
  return data;
};